// NOTE: Dependencies: jQuery

(function($) {
	$.fn.ppChart = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			charts: ('.partner-portal-chart__item')
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		};

		methods.initContext = function() {
			methods.setCurrentSettings();
		};

		methods.reviver = function(key, value) {
			var dateFormat = /^\d{4},\d{2}/;
			
			if (typeof value === "string" && dateFormat.test(value)) {
        return new Date(value);
	    }
	    
	    return value;
		}

		methods.events = function() {

			$.each($context, function(key, value) {

				var $this = $(this),
					JsonData = $this.attr('data-investment'),
					parseJsonData = JSON.parse(JsonData,methods.reviver);

				google.load("visualization", "1", {packages:["corechart"]});
				google.setOnLoadCallback(drawChart1);

				function drawChart1() {
					var data = new google.visualization.DataTable();
					
					data.addColumn('date', 'Date');
					data.addColumn('number', 'Value');

					data.addRows(parseJsonData);

					var options = {
						chartArea : { 
							left: 35,
							width: '100%'
						},						
						animation:{
							duration: 1500,
							easing: 'in-out',
							startup: true
						},
						legend: 'none',
						colors: ['#59a3eb'],
						hAxis: {
							textStyle: {color: '#8999a6'},
							baselineColor: 'transparent',
							gridlines: {
								color: 'transparent'
							},
							format: 'QQQ'
						},
						vAxis: {
							textStyle: {color: '#8999a6'},
							baselineColor: 'transparent',
							gridlines: {
								color: '#ebf4fb'
							},
							format: 'short'
						}
					};

				var chart = new google.visualization.AreaChart(document.querySelector(settings.charts));
					chart.draw(data, options);
				}

				// Todo: Need to look at throttling function
				$(window).resize(function(){
					drawChart1();
				});			

			});
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
			
		// NOTE: Method you'd like initialized on a per context basis.
		methods.initContext($(this));

		// Run once methods when jquery plugin is called.
		methods.events(this);
	};

	if ($('.partner-portal-chart__item').length) {
		$('.partner-portal-chart__item').ppChart();
	}

}(jQuery));
